<script>
    import {onMount} from 'svelte';

    import {userStore} from '@js/stores/userStore';
    import {mapStore} from '@js/stores/mapStore';
    import {searchStore} from '@js/stores/searchStore';

    import {MAP_CLASS, MAP_MODULES} from '@js/modules/maps/mapConstants';
    import MapBuilder from '@js/modules/maps/MapBuilder';

    import MapLayers from '@js/components/maps/MapLayers.svelte';

    const {
        mapId
    } = $props();

    let _previousUnit = userStore.unit;

    const _handleMapStyleChange = (mapStyle) => {
        if (!mapStore.map) {
            return;
        }

        mapStore.map.setMapStyle(mapStyle);
    };

    const _handleFontSizeChange = (delta) => {
        if (!mapStore.map) {
            return;
        }

        mapStore.map.changeMapFontSize(delta);
    };

    const _loadSearchMap = () => {
        searchStore.isSearching = true;

        MapBuilder.createMap(
            MAP_CLASS.SEARCH,
            [
                MAP_MODULES.RIDE_MARKERS,
                MAP_MODULES.RIDE_TRACK,
                MAP_MODULES.MARKER_VISIBILITY
            ],
            {
                minZoom: 12,
                mapId,
                ridesData: [],
                resetBounds: true,
                clusterMode: true,
                searchOnZoom: searchStore.ridesLoadedFromMap
            }
        )
            .then((map) => {
                if (!map) {
                    return;
                }

                mapStore.map = map;

                userStore.subscribe((userState) => {
                    if (userState.unit !== _previousUnit) {
                        _previousUnit = userState.unit;

                        mapStore.map.onUnitChanged(userState.unit);
                    }
                });
            });
    };

    onMount(() => {
        if (!mapStore.map) {
            _loadSearchMap();
        }

        return () => {
            if (mapStore.map) {
                mapStore.map.destroy();
                mapStore.map = null;
            }
        };
    });
</script>

<div id={mapId}
     class="my-4">
    <div class="map-area">
        <div id={`${mapId}-map`}
             class="map-canvas map-read-only">
            {#if $userStore.featureFlags.map_available_layers?.length}
                <MapLayers mapLayersAvailable={$userStore.featureFlags.map_available_layers}
                           onMapStyleChange={_handleMapStyleChange}
                           onFontSizeChange={_handleFontSizeChange}/>
            {/if}

        </div>
    </div>
</div>
